import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IUserData } from '../../../entity/interface/iLoginEntities';

export interface IQrCodeLoginUseCase {
    execute(
        qrCode: string,
        timestamp: number,
        language: string,
        payload: { [key: string]: any } | string
    ): Promise<IUserData>;
}

export class QrCodeLoginUseCase implements IQrCodeLoginUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        qrCode: string,
        timestamp: number,
        language: string,
        payload: { [key: string]: any } | string
    ): Promise<IUserData> {
        const response = await this.userRepo.qrCodeLogin(qrCode, timestamp, language, payload);
        return response.data;
    }
}
